// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"ef77074d","259":"130f789a","444":"130f789a","550":"987e19a4","612":"9e6155bb","772":"9e6155bb"}[chunkId] + ".chunk.css";
};